import React, { useState } from "react";
import { TextField, Box, Button, useTheme, useMediaQuery } from '@mui/material';

/**
 * 備考テキストエリア
 * @param inputItem 
 * @param inputRef
 * @returns 
 */
export const InputTextArea = ({ inputItem, inputRef }: any) => {
  // 初期値をinputItemまたはinputRefから取得
  const [localValue, setLocalValue] = useState<string>( 
    (inputRef.current !== null && inputRef.current !== "") ? inputRef.current : inputItem ? inputItem : null
  );

  // 入力変更時に親コンポーネントに値を通知
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // ローカルの状態を更新
    if (inputRef.current !== null) {
      inputRef.current = newValue; // useRefの値を更新
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TextField
        multiline
        minRows={5}
        maxRows={10}
        placeholder="入力してください"
        variant="outlined"
        fullWidth
        value={localValue} // 親から渡された値を表示
        onChange={handleInputChange} // 入力変更時に親へ通知
        disabled={inputItem !== null && inputItem !== ''}
        label="備考"
        sx={{
          backgroundColor: (inputItem !== null && inputItem !== '') ? '#f0f0f0' : 'white',
          resize: 'none'
        }}
      />
    </Box>
  );
};

/**
 * PayPayID専用の入力コンポーネント
 * @param props 
 * @returns 
 */
export const PayPayIdInput = ({ inputItem, inputRef }: any) => {
  const isRegisterInput = !inputItem; // 初回入力かどうかを示すフラグ
  const [localValue, setLocalValue] = useState<string>(inputItem);
  const [isEditable, setIsEditable] = useState(isRegisterInput);

    // レスポンシブ対応
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // モバイル用のスタイル適用
  
  // 編集モードをオンにする
  const handleEditClick = () => {
    setIsEditable(true);
  };

  // 保存ボタンが押された時に編集を終了する
  const handleSaveClick = () => {
    setIsEditable(false);
  };

  // 入力変更時に親コンポーネントに値を通知
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // ローカルの状態を更新
    if (inputRef.current !== null) {
      inputRef.current = newValue; // useRefの値を更新
    }
  };

  return (
    <>
      <TextField
        value={localValue}
        InputProps={{
          readOnly: !isEditable, // 編集可能かどうか
        }}
        onChange={handleInputChange} // 入力値を更新
        placeholder={isEditable ? "" : "入力してください"}
        sx={{
          backgroundColor: isEditable ? 'white' : '#f0f0f0',
          width: '100%'
        }}
        label="PayPayIDまたは電話番号"
      />
      <Box>
        {isRegisterInput ? (<></>) : (
          <>
          {/* 変更するボタン */}
          {!isEditable && (
            <Button
              variant="outlined"
              onClick={handleEditClick}
              sx={{
                marginTop: 2,
                width: '10%',
                padding: 1,
              }}
            >
              編集
            </Button>
          )}

          {/* 保存ボタン */}
          {isEditable && (
            <Button
              variant="contained"
              onClick={handleSaveClick}
              sx={{
                marginTop: 2,
                width: isMobile ? '100%' : '40%', // スマホでボタンが広がるようにする
                padding: 1,
              }}
            >
              編集を終了する
            </Button>
          )}
          </>
        )}
      </Box>
    </>
  );
};

/**
 * PayPay名専用の入力コンポーネント
 * @param props 
 * @returns 
 */
export const PayPayNameInput = ({ inputItem, inputRef }: any) => {
  const isRegisterInput = !inputItem; // 初回入力かどうかを示すフラグ
  const [localValue, setLocalValue] = useState<string>(inputItem);
  const [isEditable, setIsEditable] = useState(isRegisterInput);

    // レスポンシブ対応
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // モバイル用のスタイル適用
  
  // 編集モードをオンにする
  const handleEditClick = () => {
    setIsEditable(true);
  };

  // 保存ボタンが押された時に編集を終了する
  const handleSaveClick = () => {
    setIsEditable(false);
  };

  // 入力変更時に親コンポーネントに値を通知
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // ローカルの状態を更新
    if (inputRef.current !== null) {
      inputRef.current = newValue; // useRefの値を更新
    }
  };

  return (
    <>
      <TextField
        value={localValue}
        InputProps={{
          readOnly: !isEditable, // 編集可能かどうか
        }}
        onChange={handleInputChange} // 入力値を更新
        placeholder={isEditable ? "" : "入力してください"}
        sx={{
          backgroundColor: isEditable ? 'white' : '#f0f0f0',
          width: '100%'
        }}
        label="PayPay名"
      />
      <Box>
        {isRegisterInput ? (<></>) : (
          <>
          {/* 変更するボタン */}
          {!isEditable && (
            <Button
              variant="outlined"
              onClick={handleEditClick}
              sx={{
                marginTop: 2,
                width: '10%',
                padding: 1,
              }}
            >
              編集
            </Button>
          )}

          {/* 保存ボタン */}
          {isEditable && (
            <Button
              variant="contained"
              onClick={handleSaveClick}
              sx={{
                marginTop: 2,
                width: isMobile ? '100%' : '40%', // スマホでボタンが広がるようにする
                padding: 1,
              }}
            >
              編集を終了する
            </Button>
          )}
          </>
          )}
      </Box>
    </>
  );
};
